import { render, staticRenderFns } from "./insmanage.vue?vue&type=template&id=65f74641&scoped=true&"
import script from "./insmanage.vue?vue&type=script&lang=js&"
export * from "./insmanage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f74641",
  null
  
)

export default component.exports